import React, { memo } from "react";
import MobileScreenPriceChange from "../UI/MobileScreenPriceChange";

const LiveMarketTable = ({ datas }) => {
  // console.log("🚀 ~ LiveMarketTable ~ datas:", datas);
  return (
    <div className="market_body_main mt-1">
      {/* <h2 className="market_card_hading">
        Exch <i className="fas fa-chevron-down cursor-pointer"></i>
      </h2> */}
      {datas &&
        datas.length &&
        datas?.map((val, i) => (
          <div className="market_card_name live_market_card" key={i}>
            <div className="market_font">
              <div className="market_heading_box">
                <p className="market_title">
                  {val?.name}
                  <span className="market_exchange">{val?.exchange}</span>
                </p>
                <span className="market_expiry">{val?.expiry}</span>
              </div>
              <div className="market_change_box">
                <p
                  className={
                    val?.net_change < 0
                      ? "text_down market_change_percent"
                      : "text_up market_change_percent"
                  }
                >
                  {val?.net_change ?? 0}
                </p>
                <span
                  className={
                    val?.net_change < 0
                      ? "text_down market_change_percent"
                      : "text_up market_change_percent"
                  }
                >
                  ({val?.percentage_change ?? 0}%)
                </span>
              </div>
            </div>

            <div className="market_order_box">
              <MobileScreenPriceChange
                price={val?.buy_price_0}
                highLow={val?.ohlc_high}
                isText="H"
              />
              <MobileScreenPriceChange
                price={val?.sell_price_0}
                highLow={val?.ohlc_low}
                isText="L"
              />
            </div>
          </div>
        ))}
    </div>
  );
};

export default memo(LiveMarketTable);
